/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import React from 'react';

type ListProps = {
  children: React.ReactNode;
  list: unknown[];
  emptyComment: string;
};

export const List = ({
  children,
  list,
  emptyComment,
}: ListProps): JSX.Element => {
  return (
    <>
      {list.length > 0 ? (
        <div css={styles.list}>{children}</div>
      ) : (
        <div css={styles.emptyContent}>{emptyComment}</div>
      )}
    </>
  );
};

const styles = {
  list: css`
    display: flex;
    flex-direction: column;
    border-top: 1px solid #cccccc;
    border-bottom: 1px solid #cccccc;
  `,
  emptyContent: css`
    padding: 40px;
    text-align: center;
    color: #666;
    font-size: 14px;
  `,
};
